// extracted by mini-css-extract-plugin
export default {"button":"vKeIIoKeJZ98Y2WK47L3","settingsRow":"mvFQXVnwlCFAn05rgsJ_"};